import AdminSearchInput from '../../../../components/Admin/AdminSearchInput';
import { AllUserPlans } from '../Customers';

interface CustomerPlanSelectorProps {
  allUserPlans: AllUserPlans;
  handleFetchActiveUsers: (planId: string) => void;
  handleSearchInputChange: (searchTerm: string) => void;
  roleFilter: string;
  handleRoleFilterChange: (role: string) => void;
  statusFilter: string;
  handleStatusFilterChange: (status: string) => void;
  initialSearchText?: string;
}

const ROLE_OPTIONS = [
  { value: '', label: 'All Roles' },
  { value: 'user', label: 'User' },
  { value: 'teacher', label: 'Teacher' },
  { value: 'invited-user', label: 'Invited User' },
];

const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

const CustomerPlanSelector: React.FC<CustomerPlanSelectorProps> = ({
                                                                     allUserPlans,
                                                                     handleFetchActiveUsers,
                                                                     handleSearchInputChange,
                                                                     roleFilter,
                                                                     handleRoleFilterChange,
                                                                     statusFilter,
                                                                     handleStatusFilterChange,
                                                                     initialSearchText,
                                                                   }) => {
  return (
    <div className="flex flex-col gap-3 mb-2">
      {/* Stats row */}
      {allUserPlans ? (
        <div className="flex flex-col sm:flex-row justify-start gap-4 sm:gap-6">
          <p className="text-sm sm:text-base text-start">
            Total Customers: <strong>{allUserPlans?.totalUsers}</strong>
          </p>
          <p className="text-sm sm:text-base">
            Active Customers: <strong>{allUserPlans?.selectedPlanActiveUsers}</strong>
          </p>
        </div>
      ) : (
        <p className="text-sm sm:text-base">No customers found.</p>
      )}

      {/* Filters row */}
      <div className="flex flex-wrap items-end gap-3">
        {/* Search (left) */}
        <AdminSearchInput
          placeholder="Search name, email or Lead ID"
          onSearch={handleSearchInputChange}
          className="w-56"
          defaultValue={initialSearchText}
        />

        {/* Plan */}
        <div className="flex flex-col">
          <label htmlFor="planFilter" className="text-xs text-gray-500 font-semibold mb-1">Plan</label>
          <select
            id="planFilter"
            className="border border-gray-300 rounded px-2 py-1.5 text-sm bg-white"
            defaultValue=""
            onChange={(e) => handleFetchActiveUsers(e.target.value)}
          >
            <option value="" disabled>Select a Plan</option>
            <option value="">All Plans</option>
            <option value="demo_mode">Demo mode</option>
            {allUserPlans?.plans?.map((plan, i) => (
              <option key={i} value={plan.id}>{plan.name}</option>
            ))}
          </select>
        </div>

        {/* Role */}
        <div className="flex flex-col">
          <label htmlFor="roleFilter" className="text-xs text-gray-500 font-semibold mb-1">Role</label>
          <select
            id="roleFilter"
            className="border border-gray-300 rounded px-2 py-1.5 text-sm bg-white"
            value={roleFilter}
            onChange={(e) => handleRoleFilterChange(e.target.value)}
          >
            {ROLE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        {/* Status */}
        <div className="flex flex-col">
          <label htmlFor="statusFilter" className="text-xs text-gray-500 font-semibold mb-1">Status</label>
          <select
            id="statusFilter"
            className="border border-gray-300 rounded px-2 py-1.5 text-sm bg-white"
            value={statusFilter}
            onChange={(e) => handleStatusFilterChange(e.target.value)}
          >
            {STATUS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default CustomerPlanSelector;
